import React, { useState, useEffect } from "react";
import { Button, Modal } from "@mantine/core";
import { IconPlayerPlayFilled, IconCalendarMonth } from "@tabler/icons-react";
import { EmailSchedule, SmsSchedule } from "./";

export default function BulkCommunicationSchedule({
  reqData,
  onSuccess,
  id,
  isStart,
  timezone,
  timezoneOffset,
  variety,
  entityInfo,
}) {
  const initialFormValues = {
    start_date: "",
    start_time: "",
    timezone: "",
  };
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [formValues, setFormValues] = useState(initialFormValues);

  const isSms = variety === 2;

  useEffect(() => {
    if (timezone) {
      setFormValues({
        ...formValues,
        timezone,
      });
    }
  }, [timezone]);

  function onClose() {
    setOpen(false);
    setFormValues(initialFormValues);
    setLoading(false);
  }

  return (
    <>
      <Button
        leftSection={
          isStart ? (
            <IconPlayerPlayFilled size={16} />
          ) : (
            <IconCalendarMonth size={16} />
          )
        }
        onClick={() => setOpen(true)}
        size="sm"
        color={isStart ? "green" : "blue"}
        radius="lg"
      >
        {isStart ? "Start" : "Schedule"}
      </Button>
      <Modal opened={isOpen} onClose={onClose} size={"xl"}>
        {isSms ? (
          <SmsSchedule
            reqData={reqData}
            onSuccess={onSuccess}
            id={id}
            isStart={isStart}
            timezone={timezone}
            timezoneOffset={timezoneOffset}
          />
        ) : (
          <>
            <EmailSchedule
              reqData={reqData}
              onSuccess={onSuccess}
              id={id}
              isStart={isStart}
              timezone={timezone}
              timezoneOffset={timezoneOffset}
              entityInfo={entityInfo}
            />
          </>
        )}
      </Modal>
    </>
  );
}
